<template>
  <div class="home">
    <h3> Welcome </h3>
    <hr>
    <b-container class="content">
      <b-row style="padding: 0 15px; font-size: 13pt">
        <b-col sm="4" style="margin: auto; padding: 50px 0;"> 
            Creating <i class="fas fa-long-arrow-alt-right"></i>
            Breaking <i class="fas fa-long-arrow-alt-right"></i>
            Fixing <br> Hopefully in that order
        </b-col>
        <b-col sm="8" class="hellotext">
          Hello! Name's Henrik Davidsen, and welcome to my website. <br>
          Feel free to grab my resume, or just take a look around. <br><br>
          Like what you see? <router-link to="/contactme" style="color: #3E3CAD">Let me know!</router-link>
        </b-col>
      </b-row>
      <b-row class="jobstatus">
        <b-col style="text-align: right;">
          Current job status: 
        </b-col>
        <b-col style="text-align: left;">
          Actively searching
        </b-col>
      </b-row>
    </b-container>
    <h5>Hard Skills</h5>
    <table v-for="skills in hardSkills" :key="skills.id" class="skillstable">
      <tr>
        <td class="leftpane">
          <button @click="changeSkills(skills.id-1)">
            <i v-if="expandSkills[skills.id-1]" class="fas fa-minus"></i>
            <i v-else class="fas fa-plus"></i>
          </button>    
        </td>
        <td class="middlepane">
          {{skills.name}}
        </td>
        <td class="rightpane">
          <b-progress height="1.5rem" :value="skills.proficiency" :max="10"></b-progress>
        </td>
      </tr>
      <tr>
        <td></td>
        <td colspan="2" class="skilldesc">
          <transition name="skills-transition">
            <div v-if="expandSkills[skills.id-1]">
              <div v-if="skills.relatedJobs" style="margin-bottom: 7px">
                <router-link to="/resume" style="color: #3E3CAD">Positions:</router-link>
                <ul v-for="rj in skills.relatedJobs" :key="rj">
                  <li>{{rj}}</li>
                </ul>
              </div>
              <div v-if="skills.relatedProjects">
                <router-link to="/projects" style="color: #3E3CAD">Projects</router-link>
                I utilized this skill:
                <ul v-for="rp in skills.relatedProjects" :key="rp">
                  <li>{{rp}}</li>
                </ul>
              </div>
            </div>
          </transition>
        </td>
      </tr>
    </table>
    <h5 style="margin-top: 40px">Soft Skills</h5>
    <div style="margin: 0 10%">
      <div v-for="skills in softSkills" :key="skills.id" class="softtable">
        {{skills.name}}
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
  data() {
    return {
      expandSkills: [],
      hardSkills: [
        {
          id: 1,
          name: "C/C++",
          proficiency: 8,
          relatedJobs: [
            "Quality Engineer"            
          ],
          relatedProjects: [
            "Autonomous Obstacle Avoiding Vehicle",
            "Sorting Algorithm Visualizer"
          ]
        },
        {
          id: 2,
          name: "Java",
          proficiency: 7,
          relatedJobs: [
            "Quality Engineer"            
          ],
          relatedProjects: [
            "Linux Terminal Simulation"
          ]
        },
        {
          id: 3,
          name: "Bash",
          proficiency: 6,
          relatedJobs: [
            "Quality Engineer"            
          ]
        },
        {
          id: 4,
          name: "Go",
          proficiency: 8,
          relatedProjects: [
            "This website!"
          ]
        },
        {
          id: 5,
          name: "SQL",
          proficiency: 8,
          relatedJobs: [
            "Quality Engineer"            
          ],
          relatedProjects: [
            "The Pedi-Electric Sole"
          ]
        },
        {
          id: 6,
          name: "HTML/CSS",
          proficiency: 7,
          relatedProjects: [
            "This website!"
          ]
        },
        {
          id: 7,
          name: "JavaScript",
          proficiency: 7,
          relatedProjects: [
            "This website! (VueJS)"
          ]
        },
      ],
      softSkills: [
        {
          id: 1,
          name: "Agile Developement"
        },
        {
          id: 2,
          name: "Scrum"
        },
        {
          id: 3,
          name: "Time Management"
        },
        {
          id: 4,
          name: "Communication"
        },
        {
          id: 5,
          name: "Problem Solving"
        },
        {
          id: 6,
          name: "Teamwork"
        },
        {
          id: 7,
          name: "Commitment"
        },
        {
          id: 8,
          name: "Bilingual (Norwegian)"
        }
      ]
    }
  },
  methods: {
    changeSkills(aInt) {
      this.expandSkills[aInt] =! this.expandSkills[aInt];
      this.expandSkills = [...this.expandSkills];
    }
  }
}
</script>

<style scoped>

.home {
  background: white;
  border-radius: 10px;
}

.content {
  padding: 0;
}

.hellotext {
  border-left: thin solid #CBCFD0;
  margin: auto;
  font-size: 13pt;
}

.jobstatus {
  margin: 30px 0; 
  font-size: 20px;
  background-color: #DDDDDD;;
}

.skills-transition-enter-active {
  transition: all 1s ease;
  max-height: 800px;
  overflow: hidden;
}

.skills-transition-leave-active {
  transition: all 0.5s ease;
  max-height: 800px;
  overflow: hidden;
}

.skills-transition-enter,
.skills-transition-leave-to {
  max-height: 0px;
}

.skillstable {
  margin: 0 10% 15px 10%;
  background: #DDDDDD;
  border-radius: 10px;
  font-size: 15px;
}

.leftpane > * {
  border-radius: 5px;
}

.middlepane {
  width: 30%;
  padding-left: 15px;
  text-align: left;
  font-weight: bold;
}

.rightpane {
  width: 100%;  
  padding-right: 5px;
}

.skilldesc {
  text-align: left;
  padding-left: 15px;
  color: #333333;
}

.softtable {
  margin: 10px;
  background: #DDDDDD;
  border-radius: 10px;
  width: 30%;
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
}

ul {
  text-align: left;
  list-style-type: square;
  margin: 0
}
</style>